import { Link } from "react-router-dom";
import { NAV_KEYS, LOGO } from "../data";
import { useLang } from "../i18n/LanguageContext";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer data-testid="main-footer" className="bg-[#0A0D1F] text-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8">
          <div>
            <img src={LOGO} alt="JA! Consulting & Support" className="h-10 w-auto bg-white rounded-lg p-1.5" />
            <p className="text-white/60 mt-4 max-w-sm text-sm leading-relaxed">{t.footer.tagline}</p>
          </div>
          <nav className="flex flex-wrap gap-x-8 gap-y-3">
            {NAV_KEYS.map((l) => (
              <a
                key={l.href}
                href={`/${l.href}`}
                className="text-white/70 hover:text-[#4a90d9] transition-colors text-sm font-medium"
              >
                {t.nav[l.key]}
              </a>
            ))}
            <Link
              to="/impressum"
              data-testid="footer-impressum-link"
              className="text-white/70 hover:text-[#4a90d9] transition-colors text-sm font-medium"
            >
              {t.footer.impressum}
            </Link>
          </nav>
        </div>
        <div className="border-t border-white/10 mt-10 pt-6 flex flex-col sm:flex-row justify-between gap-3 text-sm text-white/50">
          <span>© {new Date().getFullYear()} JA! Consulting &amp; Support. {t.footer.rights}</span>
          <a href="mailto:info@jasupport.de" className="hover:text-white transition-colors">info@jasupport.de</a>
        </div>
      </div>
    </footer>
  );
}
